import { assign } from '@atds-legacy/lang';
import { ProgramsCollection, Resource } from '@redge-media/fo-js-sdk';
import Program from './program';

const Programs = Resource.extend({
  endpoint: 'products/lives/programmes',
  collectionClass: ProgramsCollection,
  recordClass: Program,

  constructor: function Programs(attrs = [], opts = {}) {
    Resource.call(this, attrs, opts);
  },

  deserialize(response, opts = {}) {
    const data = Resource.prototype.deserialize(response, opts);

    if (opts.op === 'fetch') {
      data.isFetched = true;
    }

    return data;
  },

  fetch(id, opts = {}) {
    const promises = [Resource.prototype.fetch.call(this, id, opts)];

    return Promise.all(promises)
      .spread((product, context) => assign(product, this.deserialize(context)));
  },
});

export default Programs;
